import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/plus.svg'
import _imports_1 from '@/assets/icons/more.svg'


const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_4 = { class: "flex flex-row items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "txt-content-title" }, "Emergency contacts", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mr-4"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Add emergency contact")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_9 = { class: "flex flex-row items-center justify-between" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row items-center ml-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-primary fill-current",
  viewBox: "0 0 20 20",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm ml-2" }, "Primary contact", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "relative flex flex-row" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  ref: "dropdown",
  class: "absolute flex flex-col text-black bg-white right-0 mr-20 mt-8 rounded-2xl shadow p-2 w-52 z-50"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<button class=\"hover:bg-background p-4 rounded\"><div class=\"flex flex-row items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6 text-gray-500\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z\"></path></svg><span class=\"txt-name text-left ml-4\">Share contact</span></div></button><div class=\"h-px w-full bg-gray-300 my-1\"></div>", 2)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-10 w-10 text-primary fill-current",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Make primary contact")
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "h-px w-full bg-gray-300 my-1"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-red-500 fill-current",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Delete contact")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "flex flex-col mt-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Contact details", -1)
const _hoisted_32 = { class: "flex flex-row mt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "w-32 text-gray-500" }, "Relationship", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_35 = { class: "flex flex-row mt-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-32 text-gray-500" }, "Phone", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_38 = { class: "flex flex-row mt-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "w-32 text-gray-500" }, "Address", -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_43 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_44 = { class: "flex flex-row items-center justify-between bg-primary-background rounded-2xl px-2 py-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "txt-name" }, "You're now editing this emergency contact", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "txt-card-title mt-4" }, "Emergency contact profile", -1)
const _hoisted_47 = { class: "flex flex-col mt-4" }
const _hoisted_48 = { class: "flex flex-row" }
const _hoisted_49 = { class: "w-1/2 mr-2" }
const _hoisted_50 = { class: "w-1/2 ml-2" }
const _hoisted_51 = { class: "flex flex-col mt-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "txt-name" }, "Contact details", -1)
const _hoisted_53 = { class: "mt-4" }
const _hoisted_54 = { class: "mt-4" }
const _hoisted_55 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_ModalEmergencyContacts = _resolveComponent("ModalEmergencyContacts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
      : (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
                      class: "btn-filled-sm"
                    }, _hoisted_7)
                  ]),
                  (_ctx.contacts.length === 0)
                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                        key: 0,
                        name: "emergency contacts",
                        class: "mt-4"
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "flex flex-col mb-8"
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_UserCard, {
                                  firstName: contact.first_name,
                                  lastName: contact.last_name
                                }, null, 8, ["firstName", "lastName"]),
                                (contact.primary)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.showDropdown(contact.id)),
                                  class: "px-2"
                                }, _hoisted_18, 8, _hoisted_16),
                                (contact.id === _ctx.openDropdown)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _hoisted_20,
                                      (!contact.primary)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.makePrimary(contact.id)),
                                            class: "hover:bg-background p-4 rounded"
                                          }, _hoisted_24, 8, _hoisted_22))
                                        : _createCommentVNode("", true),
                                      (!contact.primary)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.deleteContact(contact.id)),
                                        class: "hover:bg-background p-4 rounded"
                                      }, _hoisted_28, 8, _hoisted_26)
                                    ], 512))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.startEditing(i)),
                                  class: "btn-outline-sm ml-4"
                                }, " Edit ", 8, _hoisted_29)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("div", null, _toDisplayString(contact.relationship), 1)
                              ]),
                              _hoisted_34,
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("div", null, _toDisplayString(contact.phone), 1)
                              ]),
                              _hoisted_37,
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                (contact.address)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(contact.address), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_41, "Not specified"))
                              ]),
                              _hoisted_42
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                class: "btn-filled-sm"
              }, "Done editing")
            ]),
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.first_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.first_name) = $event)),
                    name: "first_name",
                    label: "First name",
                    error: _ctx.errors.first_name
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.last_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.last_name) = $event)),
                    name: "last_name",
                    label: "Last name",
                    error: _ctx.errors.last_name
                  }, null, 8, ["modelValue", "error"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.relationship,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.relationship) = $event)),
                    name: "relationship",
                    label: "Relationship",
                    error: _ctx.errors.relationship
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event)),
                    name: "phone",
                    label: "Phone",
                    error: _ctx.errors.phone
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.address,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address) = $event)),
                    name: "address",
                    label: "Address (Optional)"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])),
    _createVNode(_component_ModalEmergencyContacts, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openModal) = $event)),
      talent_id: _ctx.talent_id
    }, null, 8, ["openModal", "talent_id"])
  ]))
}